const defaultRoute = '/'

export const router = (key, folder, absolute = false) => {
  try {
    if (!(key && folder)) {
      return defaultRoute
    }

    if (routes[folder]) {
      const keys = key.split('.')
      let current = 0, next = routes[folder][keys[current]]

      if (!next) {
        return defaultRoute
      }

      while (typeof next !== 'string') {
        current++;
        next = next[keys[current]]
      }

      if (absolute) {
        return next
      } else {
        return `/${folder}/${next}`
      }
    }

    return defaultRoute
  } catch (error) {
    console.warn('Errore nel link: ' + key)
    console.log(error)
    return defaultRoute
  }
}

const routes = {
  'it-it': {
    'home': '',
    'contacts': 'contatti/',
    'search': 'cerca/',
    'login': 'accedi/',
    'contact-sales': 'contatti/informazioni-commerciali/',
    'customer-stories': {
      'customer-stories': 'industry/customer-stories/',
      'fintech': 'industry/fintech/',
      'horeca': 'industry/horeca/',
      'insurance': 'industry/insurance/',
      'banking': 'industry/financial-services/',
      'fashion': 'industry/fashion/',
      'automotive': 'industry/soluzioni-embedded-finance-settore-automotive/',
      'toyota': 'industry/customer-stories/fabrick-e-toyota-la-finanza-integrata-nella-mobilita',
    },
    'products': {
      'psd2Services': {
        'aisp': 'prodotti/aisp/',
        'pisp': 'prodotti/pisp/',
        'fast-scoring': 'prodotti/fast-scoring/',
        'personalFinance': 'prodotti/personal-financial-management/',
        'bankingAsService': 'prodotti/banking-as-a-service/',
        'bankCoverage': 'prodotti/bank-coverage-api/',
      },
      'endToEndSolutions': {
        'financeOrchestration': 'prodotti/payment-orchestration/',
        'sepa': 'prodotti/digital-mandate-sdd/',
        'paymentGate': 'prodotti/payment-gateway/',
        'riskAnalysis': 'prodotti/analisi-del-rischio-esenzione-sca/',
        'guaranteedPayments': 'prodotti/fraud-prevention/',
        'facilitator': 'prodotti/payment-facilitator/',
        'financialSplitPayment': 'prodotti/financial-split-payments/',
      },
      'bankingServices': {
        'businessFinance': 'prodotti/business-financial-management/',
        'smeBanking': 'prodotti/sme-banking/',
        'lendingPlace': 'prodotti/lending/',
        'onboarding': 'prodotti/customer-digital-onboarding/',
        'checkIban': 'prodotti/check-iban/',
        'smartBanking': 'prodotti/fabrick-smart-banking',
      },
      'inStoreSolutions': {
        'tapToPay': 'prodotti/tap-to-pay/',
        'tapToPayIphone': 'prodotti/tap-to-pay/tap-to-pay-su-iphone/',
        'tapToPayAndroid': 'prodotti/tap-to-pay/tap-to-pay-su-android/',
        'tapToPayApi': 'prodotti/tap-to-pay/tap-to-pay-su-android-via-api/',
        'tapToPayContactUs': 'prodotti/tap-to-pay/tap-to-pay-su-android/contattaci',
        'verificationPayee': 'prodotti/verification-of-payee/',
        'posEasyCommissioni': 'https://www.axerve.com/soluzioni-pos/pos-easy-commissioni',
        'posEasyCanone': 'https://www.axerve.com/soluzioni-pos/pos-easy-canone',
        'payByLink': 'https://www.axerve.com/soluzioni-di-incasso/pay-by-link',
        'digitalizzazioneContante': 'https://www.axerve.com/soluzioni-di-incasso/digitalizzazione-contante',
      }
    },
    'footer': {
      'cookie-policy': 'privacy/',
      'terms': 'termini-e-condizioni/',
      'complaints': 'reclami-ricorsi-e-mediazione/',
      'status-page': 'https://status.fabrick.com',
      'transparency': 'trasparenza/',
      'accessibility': 'accessibilita/',
      'whistleblowing': 'whistleblowing/',
      'reportSustainability': 'rendicontazione-di-sostenibilita/',
      'massimaliCommerciali': 'massimali-informazioni-commerciali/',
      'informativaCommerciale': 'privacy/privacy-policy-servizi-di-informazione-commerciale/',
      'privacy': 'privacy-and-cookie/privacy-policy/',
      'ethicalCode': 'https://landing.fabrick.com/hubfs/mkt/policies/BSH_CODICE_ETICO_IT.pdf',
    },
    'career': 'fabrick-people/unisciti-al-team/',
    'careerTP': 'unisciti-al-team/grazie/',
    'insight': 'insight/',
    'insights': {
      'articles': 'insight/blog/',
      'whitepaper': 'insight/whitepaper/',
      'video': 'insight/video/',
      'podcast': 'insight/podcast/',
      'webinar': 'insight/webinar/',
      'newsletter': 'newsletter/',
    },
    'whitepaper-pay-by-bank': 'insight/whitepaper/pay-by-bank-bonifici-precompilati/',
    'support': {
      'faq': 'https://developers.fabrick.com',
      'customer-support': 'assistenza/',
      'support': 'assistenza/',
      'axerve': 'assistenza/faq/',
      'axerve-dashboard': 'assistenza/axerve-dashboard/',
      'payment-gateway': 'assistenza/payment-gateway/',
      'support-form-open-payments': 'assistenza/assistenza-open-payments/',
      'support-form-fabrick': 'https://fabrick-platform.atlassian.net/servicedesk/customer/portals',
      'support-form-axerve': 'https://www.axerve.com/assistenza/assistenza-tecnica',
      'cancel-contract-faq': 'assistenza/payment-gateway/disdire-unofferta-ecommerce/'
    },
    'developers': {
      'api': 'dev/api/',
      'fabrick-producers': 'dev/producers/',
      'tpp-portal': 'dev/tpp-portal/',
      'assistenza-tecnica': 'assistenza-tecnica/',
      'startup-solutions': 'startup-soluzioni-fintech/',
    },
    'aboutFabrick': {
      'mission': 'corporate/mission/',
      'platform': 'corporate/piattaforma-open-finance/',
      'ecosystem': 'corporate/ecosistema/',
      'team': 'corporate/management-team/',
      'history': 'corporate/storia/',
    },
    'fabrickPeople': {
      'joinUs': 'fabrick-people/unisciti-al-team/',
      'whyFabrick': 'fabrick-people/perche-fabrick/',
      'ourTeam': 'fabrick-people/il-nostro-team/',
    },
    'mediaHub': {
      'pressReleases': 'media-hub/comunicati-stampa/',
      'pressReview': 'media-hub/rassegna-stampa/',
      'events': 'media-hub/eventi/',
      'mediaKit': 'media-hub/media-kit/',
    },
    'tapToPay': {
      'onboarding-android': 'tap-to-pay-onboarding-android',
      'onboarding-ios': 'tap-to-pay-onboarding-ios',
    }
  },
  'en-gb': {
    'home': '',
    'contacts': 'contacts/',
    'sales': 'contacts/sales/',
    'search': 'search/',
    'login': 'login/',
    'contact-sales': 'contacts/sales/',
    'customer-stories': {
      'customer-stories': 'industry/customer-stories/',
      'fintech': 'industry/fintech/',
      'horeca': 'industry/horeca/',
      'insurance': 'industry/insurance/',
      'banking': 'industry/financial-services/',
      'fashion': 'industry/fashion/',
      'automotive': 'industry/embedded-finance-solutions-for-automotive/',
      'toyota': 'industry/customer-stories/toyota-and-fabrick-innovative-financial-services-for-mobility',
    },
    'products': {
      'psd2Services': {
        'aisp': 'product/aisp/',
        'pisp': 'product/pisp/',
        'fast-scoring': '',
        'creditRating': '',
        'personalFinance': '',
        'bankingAsService': '',
        'bankCoverage': 'product/bank-coverage-api/',
      },
      'endToEndSolutions': {
        'financeOrchestration': 'product/payment-orchestration/',
        'sepa': 'digital-mandate-sdd/',
        'paymentGate': 'product/payment-gateway/',
        'riskAnalysis': 'product/risk-analysis-sca-exemptions/',
        'guaranteedPayments': 'product/fraud-prevention/',
        'facilitator': 'product/payment-facilitator/',
        'financialSplitPayment': 'product/financial-split-payments/',
      },
      'bankingServices': {
        'businessFinance': '',
        'smeBanking': '',
        'lendingPlace': 'product/lending-place/',
        'onboarding': '',
        'checkIban': '',
        'smartBanking': 'product/fabrick-smart-banking',
      },
      'inStoreSolutions': {
        'tapToPay': 'prodotti/tap-to-pay/',
        'tapToPayIphone': 'prodotti/tap-to-pay/tap-to-pay-su-iphone/',
        'tapToPayAndroid': 'prodotti/tap-to-pay/tap-to-pay-su-android/',
        'verificationPayee': 'prodotti/verification-of-payee/',
        'posEasyCommissioni': 'https://www.axerve.com/soluzioni-pos/pos-easy-commissioni',
        'posEasyCanone': 'https://www.axerve.com/soluzioni-pos/pos-easy-canone',
        'payByLink': 'https://www.axerve.com/soluzioni-di-incasso/pay-by-link',
        'digitalizzazioneContante': 'https://www.axerve.com/soluzioni-di-incasso/digitalizzazione-contante',
      }
    },
    'footer': {
      'cookie-policy': 'privacy/',
      'terms': 'terms-conditions/',
      'complaints': 'complaints-and-dispute-settlement-systems/',
      'status-page': 'https://status.fabrick.com',
      'transparency': 'transparency/',
      'accessibility': 'accessibility/',
      'whistleblowing': 'whistleblowing/',
      'privacy': 'privacy-and-cookie/privacy-policy/',
      'massimaliCommerciali': 'massimali-informazioni-commerciali/',
      'informativaCommerciale': 'privacy/privacy-policy-servizi-di-informazione-commerciale/',
      'ethicalCode': 'https://landing.fabrick.com/hubfs/mkt/policies/BSH_CODICE_ETICO_EN.pdf',
    },
    'career': 'fabrick-people/join-us/',
    'careerTP': 'join-us/thank-you/',
    'insight': 'insight/',
    'insights': {
      'articles': 'insights/blog/',
      'whitepaper': 'insights/whitepaper/',
      'video': 'insights/video/',
      'podcast': 'insights/podcast/',
      'webinar': 'insights/webinar/',
      'newsletter': 'newsletter/',
    },
    'whitepaper-pay-by-bank': 'insight/whitepaper/pay-by-bank-bonifici-precompilati/',
    'support': {
      'faq': 'https://developers.fabrick.com',
      'customer-support': 'support/',
      'support': 'support/',
      'axerve': 'support/faq/',
      'axerve-dashboard': 'support/axerve-dashboard/',
      'payment-gateway': 'support/payment-gateway/',
      'support-form-open-payments': 'support/support-open-payments/',
      'support-form-fabrick': 'https://fabrick-platform.atlassian.net/servicedesk/customer/portals',
      'support-form-axerve': 'https://www.axerve.com/assistenza/assistenza-tecnica',
      'cancel-contract-faq': 'support/payment-gateway/cancel-an-ecommerce-contract/'
    },
    'developers': {
      'api': 'dev/api/',
      'fabrick-producers': 'dev/producers/',
      'tpp-portal': 'dev/tpp-portal/',
      'assistenza-tecnica': 'support/',
      'startup-solutions': 'startup-fintech-solutions/',
    },
    'aboutFabrick': {
      'mission': 'corporate/mission/',
      'platform': 'corporate/platform-open-finance/',
      'ecosystem': 'corporate/ecosystem/',
      'team': 'corporate/management-team/',
      'history': 'corporate/history/',
    },
    'fabrickPeople': {
      'joinUs': 'fabrick-people/join-us/',
      'whyFabrick': 'fabrick-people/why-fabrick/',
      'ourTeam': 'fabrick-people/our-team/',
    },
    'mediaHub': {
      'pressReleases': 'media-hub/press/',
      'pressReview': 'media-hub/press-review/',
      'events': 'media-hub/events/',
      'mediaKit': 'media-hub/media-kit/',
    }
  },
  'es-es': {
    'home': '',
    'contacts': 'contactos/',
    'search': 'buscar/',
    'login': 'iniciar-sesion/',
    'customer-stories': {
      'customer-stories': 'industrias/casos-de-exito/',
      'fintech': 'industrias/fintech/',
      'horeca': 'industrias/horeca/',
      'insurance': 'industrias/seguros/',
      'banking': 'industrias/servicios-financieros/',
      'fashion': 'industrias/moda/',
      'automotive': '',
    },
    'products': {
      'psd2Services': {
        'aisp': 'productos/aisp/',
        'pisp': 'productos/pisp/',
        'fast-scoring': '',
        'creditRating': '',
        'personalFinance': 'productos/personal-financial-management/',
        'bankingAsService': '',
        'bankCoverage': 'productos/bank-coverage-api/',
      },
      'endToEndSolutions': {
        'financeOrchestration': 'productos/payment-orchestration/',
        'sepa': 'digital-mandate-sdd/',
        'paymentGate': 'productos/pasarela-de-pago/',
        'riskAnalysis': 'productos/analisis-riesgos-transacciones/',
        'guaranteedPayments': 'productos/prevencion-del-fraude/',
        'facilitator': 'productos/payment-facilitator/',
      },
      'bankingServices': {
        'businessFinance': '',
        'smeBanking': '',
        'lendingPlace': 'productos/lending-place/',
        'onboarding': '',
        'checkIban': '',
        'smartBanking': 'productos/fabrick-smart-banking',
      },
      'inStoreSolutions': {
        'tapToPay': 'prodotti/tap-to-pay/',
        'tapToPayIphone': 'prodotti/tap-to-pay/tap-to-pay-su-iphone/',
        'tapToPayAndroid': 'prodotti/tap-to-pay/tap-to-pay-su-android/',
        'verificationPayee': 'prodotti/verification-of-payee/',
        'posEasyCommissioni': 'https://www.axerve.com/soluzioni-pos/pos-easy-commissioni',
        'posEasyCanone': 'https://www.axerve.com/soluzioni-pos/pos-easy-canone',
        'payByLink': 'https://www.axerve.com/soluzioni-di-incasso/pay-by-link',
        'digitalizzazioneContante': 'https://www.axerve.com/soluzioni-di-incasso/digitalizzazione-contante',
      }
    },
    'footer': {
      'cookie-policy': 'privacidad/',
      'terms': 'terms-conditions/',
      'complaints': 'reclamaciones-y-recursos/',
      'status-page': 'https://status.fabrick.com',
      'transparency': 'transparencia/',
      'accessibility': 'accesibilidad/',
      'whistleblowing': 'whistleblowing/',
      'privacy': 'privacy-and-cookie/privacy-policy/',
      'massimaliCommerciali': 'massimali-informazioni-commerciali/',
      'informativaCommerciale': 'privacy/privacy-policy-servizi-di-informazione-commerciale/',
      'ethicalCode': 'https://landing.fabrick.com/hubfs/mkt/policies/BSH_CODICE_ETICO_EN.pdf',
    },
    'career': 'fabrick-people/unete-al-equipo/',
    'careerTP': 'unete-al-equipo/gracias/',
    'insight': 'insight/',
    'insights': {
      'articles': 'recursos/blog/',
      'whitepaper': 'recursos/libros-blancos/',
      'video': 'insights/video/',
      'podcast': 'insights/podcast/',
      'webinar': 'insights/webinar/',
      'newsletter': 'newsletter/',
    },
    'support': {
      'faq': 'https://developers.fabrick.com',
      'customer-support': 'asistencia/',
      'support': 'asistencia/',
      'axerve': 'asistencia/faq/',
      'axerve-dashboard': 'asistencia/axerve-dashboard/',
      'payment-gateway': 'asistencia/pasarela-de-pago/',
      'support-form-open-payments': 'asistencia/asistencia-open-payments/',
      'support-form-fabrick': 'https://fabrick-platform.atlassian.net/servicedesk/customer/portals',
      'support-form-axerve': 'https://www.axerve.com/assistenza/assistenza-tecnica',
      'cancel-contract-faq': 'asistencia/pasarela-de-pago/anular-un-contrato-ecommerce/'
    },
    'developers': {
      'api': 'dev/api/',
      'fabrick-producers': 'dev/producers/',
      'tpp-portal': 'dev/tpp-portal/',
      'assistenza-tecnica': 'asistencia/',
      'startup-solutions': 'startup-fintech-solutions/',
    },
    'aboutFabrick': {
      'mission': 'corporate/mission/',
      'platform': 'corporate/plataforma-open-finance/',
      'ecosystem': 'corporate/ecosistema/',
      'team': 'corporate/equipo-directivo/',
      'history': 'corporate/historia/',
    },
    'fabrickPeople': {
      'joinUs': 'fabrick-people/unete-al-equipo/',
      'whyFabrick': 'fabrick-people/por-que-fabrick/',
      'ourTeam': 'fabrick-people/nuestro-equipo/',
    },
    'mediaHub': {
      'pressReleases': 'media-hub/comunicados-de-prensa/',
      'pressReview': 'media-hub/resena-de-prensa/',
      'events': 'media-hub/eventos/',
      'mediaKit': 'media-hub/media-kit/',
    }
  },
  'fr-fr': {
    'home': '',
    'contacts': 'contacts/',
    'search': 'recherche/',
    'login': 'login/',
    'customer-stories': {
      'customer-stories': 'industries/etudes-de-cas/',
      'fintech': 'industries/fintech/',
      'horeca': 'industries/horeca/',
      'insurance': 'industries/assurance/',
      'banking': 'industries/services-financiers/',
      'fashion': 'industries/mode/',
      'automotive': '',
    },
    'products': {
      'psd2Services': {
        'aisp': 'produits/aisp/',
        'pisp': 'produits/pisp/',
        'fast-scoring': '',
        'creditRating': '',
        'personalFinance': 'produits/personal-financial-management/',
        'bankingAsService': '',
        'bankCoverage': 'produits/bank-coverage-api/',
      },
      'endToEndSolutions': {
        'financeOrchestration': 'produits/payment-orchestration/',
        'sepa': '',
        'paymentGate': 'produits/passerelle-de-paiement/',
        'riskAnalysis': 'produits/analyse-des-risques-de-transactions/',
        'guaranteedPayments': 'produits/prevention-de-la-fraude/',
        'facilitator': 'produits/payment-facilitator/',
      },
      'bankingServices': {
        'businessFinance': '',
        'smeBanking': '',
        'lendingPlace': 'produits/lending-place/',
        'onboarding': '',
        'checkIban': '',
        'smartBanking': 'produits/fabrick-smart-banking',
      },
      'inStoreSolutions': {
        'tapToPay': 'prodotti/tap-to-pay/',
        'tapToPayIphone': 'prodotti/tap-to-pay/tap-to-pay-su-iphone/',
        'tapToPayAndroid': 'prodotti/tap-to-pay/tap-to-pay-su-android/',
        'verificationPayee': 'prodotti/verification-of-payee/',
        'posEasyCommissioni': 'https://www.axerve.com/soluzioni-pos/pos-easy-commissioni',
        'posEasyCanone': 'https://www.axerve.com/soluzioni-pos/pos-easy-canone',
        'payByLink': 'https://www.axerve.com/soluzioni-di-incasso/pay-by-link',
        'digitalizzazioneContante': 'https://www.axerve.com/soluzioni-di-incasso/digitalizzazione-contante',
      }
    },
    'footer': {
      'cookie-policy': 'confidentialite/',
      'terms': '',
      'complaints': 'reclamations-et-resolution-de-conflits/',
      'status-page': 'https://status.fabrick.com',
      'transparency': 'transparence/',
      'accessibility': 'accessibilite/',
      'whistleblowing': 'whistleblowing/',
      'privacy': '',
      'massimaliCommerciali': 'massimali-informazioni-commerciali/',
      'informativaCommerciale': 'privacy/privacy-policy-servizi-di-informazione-commerciale/',
      'ethicalCode': 'https://landing.fabrick.com/hubfs/mkt/policies/BSH_CODICE_ETICO_EN.pdf',
    },
    'career': 'fabrick-people/rejoignez-lequipe/',
    'careerTP': 'rejoignez-lequipe/merci/',
    'insight': '',
    'insights': {
      'articles': 'ressources/blog/',
      'whitepaper': 'ressources/livres-blancs/',
      'video': 'ressources/video/',
      'podcast': 'ressources/podcast/',
      'webinar': 'ressources/webinar/',
      'newsletter': 'newsletter/',
    },
    'support': {
      'faq': 'https://developers.fabrick.com',
      'customer-support': 'assistance/',
      'support': 'assistance/',
      'axerve': 'assistance/faq/',
      'axerve-dashboard': 'assistance/axerve-dashboard/',
      'payment-gateway': 'assistance/passerelle-de-paiement/',
      'support-form-open-payments': 'assistance/assistance-open-payments/',
      'support-form-fabrick': 'https://fabrick-platform.atlassian.net/servicedesk/customer/portals',
      'support-form-axerve': 'https://www.axerve.com/assistenza/assistenza-tecnica',
      'cancel-contract-faq': 'assistance/passerelle-de-paiement/cancel-an-ecommerce-contract/'
    },
    'developers': {
      'api': 'dev/api/',
      'fabrick-producers': 'dev/producers/',
      'tpp-portal': 'dev/tpp-portal/',
      'assistenza-tecnica': 'assistance/',
      'startup-solutions': 'startup-fintech-solutions/',
    },
    'aboutFabrick': {
      'mission': 'corporate/mission/',
      'platform': 'corporate/plateforme-open-finance/',
      'ecosystem': 'corporate/ecosysteme/',
      'team': 'corporate/equipe-de-direction/',
      'history': 'corporate/notre-histoire/',
    },
    'fabrickPeople': {
      'joinUs': 'fabrick-people/rejoignez-lequipe/',
      'whyFabrick': 'fabrick-people/pourquoi-fabrick/',
      'ourTeam': 'fabrick-people/notre-equipe/',
    },
    'mediaHub': {
      'pressReleases': 'media-hub/communiques-de-presse/',
      'pressReview': 'media-hub/revue-de-presse/',
      'events': 'media-hub/evenements/',
      'mediaKit': 'media-hub/media-kit/',
    }
  }
}